import React, { useEffect } from 'react'
import Note from './note';
import { NoteService } from '../../services/noteService';

export default function NoteGroup({ groupTitle, isArchived, notes, numberOfNotes, selectedNotes, toggleSelectedNote }) {
    if(isArchived) {
        return (
            <li className="bookmarks__border">
                <div className="bookmarks__item">
                    <div className="bookmarks__link  bookmarks__link--heading">{groupTitle} <span className="notifications__archived">Upphävt</span></div>
                </div>
            </li>
        )
    }

    const [expanded, setExpanded] = React.useState(false);
    const [categories, setCategories]= React.useState([]);

    const selectedInGroup = notes.filter(note =>
        selectedNotes.includes(note.id)
    );

    const allSelected =
        notes.length > 0 &&
        selectedInGroup.length === notes.length;

    const isIndeterminate =
        selectedInGroup.length > 0 &&
        selectedInGroup.length < notes.length;

    const toggleAll = (checked) => {
        notes.forEach(note => {
            const isSelected = selectedNotes.includes(note.id);

            if (checked && !isSelected) {
                toggleSelectedNote(note.id);
            }

            if (!checked && isSelected) {
                toggleSelectedNote(note.id);
            }
        });
    };

    const noteCountLabel = `${numberOfNotes} anteckning${numberOfNotes === 1 ? '' : 'ar'}`;

    return (
        <li className="bookmarks__border">
            <button
                type="button"
                className="bookmarks__item  bookmarks__item--clickable"
                onClick={() => { setExpanded(!expanded) }}
                aria-expanded={expanded}
                aria-label={`${groupTitle}, ${noteCountLabel}`}
            >
                <div className="bookmarks__link  bookmarks__link--heading" aria-hidden="true">{groupTitle}</div>
                <div aria-hidden="true">
                    <div className="bookmarks__amount">{numberOfNotes}</div>
                </div>
                <div className={`bookmarks__arrow  ${expanded && 'bookmarks__arrow--up'}`} aria-hidden="true"></div>
            </button>

            <label
                className="notes__select-all"
            >
                <input
                    type="checkbox"
                    className="notifications__select-checkbox"
                    checked={allSelected}
                    onChange={() => toggleAll(!allSelected)}
                    ref={(el) => {
                        if (el) {
                            el.indeterminate = isIndeterminate;
                        }
                    }}
                />
                <span>
                    {allSelected ? "Avmarkera alla" : "Markera alla"}
                </span>
            </label>

            <ul className="notes__sublist" role="presentation">
            {
                expanded
                ? notes.map((note, index) => <Note note={note} selectedNotes={selectedNotes} toggleSelectedNote={toggleSelectedNote} key={index}/>)
                : null
            }
            </ul>
        </li>
    )
}
